import React from "react";
import { TorahAnytimeHeaderTemplate } from "themes/application/torah-anytime/components";

function TorahAnytimeHeader(props) {
    return <TorahAnytimeHeaderTemplate {...props} />;
}

export default TorahAnytimeHeader;
